import { ReactComponent as GhostProfileIcon } from '../../../icons/thumbnail.ghost.profile.svg';

interface ThreadContentItemProps {
  speaker?: string;
  text: string;
  className?: string;
  hasLine?: boolean;
}

const ThreadContentItem = ({
  speaker,
  text,
  className,
  hasLine = true
}: ThreadContentItemProps) => {
  return (
    <div className={`px-[22px] py-[15px] flex gap-[10px] items-stretch ${className}`}>
      <div className="flex flex-col items-center gap-[8px]">
        <GhostProfileIcon width={26} height={26} />
        {hasLine && (
          <div className="w-[2px] flex-1 mb-[-20px] rounded-[16px] bg-[rgba(255,255,255,0.13)]" />
        )}
      </div>
      <div className="flex flex-col items-start gap-[5px] flex-1">
        <p className="text-[14px] font-semibold leading-[17px] text-separator-light-1">
          {speaker ?? '익명의 제보자'}
        </p>
        <p className="text-[15px] leading-[19px] text-pure-white">{text}</p>
      </div>
    </div>
  );
};

export default ThreadContentItem;
